import request from "utils/request";

export async function checkArticleBalance(payload) {
	return request("/action/check_balance/article", {
		method: "POST",
		body: payload
	})
}

export async function addBlockedSites(payload) {
	return request("/rest/blocked_sites", {
		method: "POST",
		body: payload
	});
}

export async function deleteBlockedSites(payload) {
	return request("/rest/blocked_sites", {
		method: "DELETE",
		body: payload
	})
}

export async function addProxies(payload) {
	return request("/rest/proxies", {
		method: "POST",
		body: payload
	});
}

export async function deleteProxies(payload) {
	return request("/rest/proxies", {
		method: "DELETE",
		body: payload
	});
}

export async function checkProxies() {
	return request("/action/check/proxies");
}

export async function stopCheckingProxies() {
	return request("/action/stop_checking/proxies");
}

export async function testSpinArticle(params) {
	return request("/action/spin/test", {
		method: "POST",
		body: params
	});
}

export async function saveOptions(params) {
	return request("/rest/options", {
		method: "POST",
		body: params
	});
}
